import axiosInstance from '../../../config/axiosInstance';
import type { EconomicPriceObservationsResponse } from '../types/economicPriceObservations';

// ECON-ATTN-01A: servicio de cribado económico; no ejecuta acciones.
export async function getEconomicPriceObservations(params: {
  limit?: number;
  cursor?: string;
} = {}): Promise<EconomicPriceObservationsResponse> {
  const { data } = await axiosInstance.get<EconomicPriceObservationsResponse>(
    '/pricing/margin-center/attention/economic/price-observations',
    { params },
  );
  return data;
}
